import { useEffect, useMemo, useState } from "react";
import clsx from "clsx";
import { TooltipComponent } from "../../components/ui/Tooltip";
import { InfoIcon } from "../../icons";
import Loader from "../../components/elements/loader";

export const NotificationsMobileAppGuide = () => {

    const indicatorsList = useMemo(()=>{
        return [
            {
                "id": "1",
                "name": "lowOilPressure",
                "label": "Χαμηλή πίεση λαδιού",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-001-oil-low",
                "message": {
                    "label": "Ακινητοποίησε άμεσα το αυτοκίνητο και κάλεσε την Οδική Βοήθεια στο",
                    "phone": "+302106879800"
                },
            },
            {
                "id": "2",
                "name": "temperature",
                "label": "Πρόβλημα στο σύστημα ψύξης",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-002-temp",
                "message": {
                    "label": "Ακινητοποίησε άμεσα το αυτοκίνητο και κάλεσε την Οδική Βοήθεια στο",
                    "phone": "+302106879800"
                },
            },
            {
                "id": "3",
                "name": "steering",
                "label": "Πρόβλημα στο τιμόνι",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-003-steering",
                "message": {
                    "label": "Ακινητοποίησε άμεσα το αυτοκίνητο και κάλεσε την Οδική Βοήθεια στο",
                    "phone": "+302106879800"
                },
            },
            {
                "id": "4",
                "name": "abs",
                "label": "Πρόβλημα στο ABS",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-004",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "5",
                "name": "checkEnging",
                "label": "Δυσλειτουργία κινητήρα",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-005",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "6",
                "name": "oilLevel",
                "label": "Χαμηλή/υψηλή στάθμη λαδιού",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-006",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "7",
                "name": "glowPlugs",
                "label": "Πρόβλημα στους προθερμαντήρες",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-007",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "8",
                "name": "tyrePressure",
                "label": "Έλεγχος πίεσης ελαστικού",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-008",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα ένα κατάστημα ελαστικών."
                },
            },
            {
                "id": "9",
                "name": "adBlue1",
                "label": "Συμπλήρωση Adblue",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-009",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα ένα πρατήριο καυσίμων ή συνεργείο."
                },
            },
            {
                "id": "10",
                "name": "adBlue2",
                "label": "Συμπλήρωση Adblue",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-010",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα ένα πρατήριο καυσίμων ή συνεργείο."
                },
            },
            {
                "id": "11",
                "name": "filter",
                "label": "Κορεσμός φίλτρου σωματιδίων DPF",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-011",
                "message": {
                    "label": "Συνέχισε να οδηγείς για τουλάχιστον 15 λεπτά με ταχύτητα από 40 έως και 60 χλμ/ώρα. Σε περίπτωση που η ένδειξη παραμείνει, θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "12",
                "name": "airbag1",
                "label": "Πρόβλημα αερόσακου",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-012",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "13",
                "name": "airbag2",
                "label": "Πρόβλημα αερόσακου",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-013",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "14",
                "name": "airbag3",
                "label": "Πρόβλημα αερόσακου",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-014",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "15",
                "name": "battery",
                "label": "Πρόβλημα στη λειτουργία της μπαταρίας",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-015",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "16",
                "name": "breakPads",
                "label": "Φθαρμένα τακάκια",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-016",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },  
            },
            {
                "id": "17",
                "name": "breakFluid1",
                "label": "Χαμηλή στάθμη υγρών φρένων",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-017",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "18",
                "name": "breakFluid2",
                "label": "Χαμηλή στάθμη υγρών φρένων",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-018",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "19",
                "name": "transmission",
                "label": "Πρόβλημα στο αυτόματο σασμάν",
                "url": "https://uatclients.myavis.gr/api/car-icons/icon-019",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            },
            {
                "id": "other-yellow-orange",
                "name": "other-red",
                "label": "other-red",
                "url": "",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς το συνεργείο στο άμεσο μέλλον."
                },
            },
            {
                "id": "other-red",
                "name": "other-red",
                "label": "other-red",
                "url": "",
                "message": {
                    "label": "Θα πρέπει να επισκεφτείς άμεσα το συνεργείο."
                },
            }
        ]
    },[])

    const [selectedIcon, setSelectedIcon] = useState(null)
    const [message, setMessage] = useState();

    useEffect(() => {
        setMessage(indicatorsList?.filter((item)=> item.id === selectedIcon)?.[0]?.message)
    }, [indicatorsList, selectedIcon]);


    const handleSubmit = (list) => {
        setSelectedIcon(list?.[0])
    }

    return (
       <div className="flex items-center flex-col gap-5 container mx-auto max-md:px-10 h-fit" style={{ minHeight: 'calc(100vh - 140px)' }}>
            <div className="flex gap-2 items-center w-full pt-6">
                {/* <LeftArrow className={'cursor-pointer'} onClick={()=>{navigate('/')}}/> */}
                <p className="h3">Οδηγός Ενδείξεων</p>
            </div>
            <div className="flex w-full gap-6 mb-6">
                <div className="flex flex-col gap-8 w-full lg:w-fit">
                    <div className="p-6 bg-[#F5F5F7] flex flex-col gap-3 rounded-[12px] border border-[#A5A5A5]">
                        <h4>Oδηγίες</h4>
                        <div className="text-body-large">
                            <p className="text-body">• Θέσε τον κινητήρα σε λειτουργία.</p>
                            <p  className="text-body">• Περίμενε για 30 δευτερόλεπτα.</p>
                            <p  className="text-body">• Από τον παρακάτω πίνακα, επίλεξε τα εικονίδια που εμφανίζονται στον πίνακα οργάνων του αυτοκινήτου.</p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-8 max-lg:gap-4 max-lg:mx-auto max-lg:items-center">
                        <h4>Επίλεξε την ένδειξη που εμφανίζεται</h4>
                        <div className="w-fit grid grid-cols-6 gap-3 lg:gap-5 items-center">
                            
                            {indicatorsList && indicatorsList.map(item =>
                                <TooltipComponent content={item.label}>
                                    <img alt='' width={60} onClick={() => {setSelectedIcon(item.id)}} key={item.id} className={clsx("rounded-[6px] cursor-pointer border-2",indicatorsList.find(select => select === item.id) !== undefined ? 'border-[#FF0000]' : 'border-transparent')} src={item.url} />
                                </TooltipComponent>
                            )}
                        </div>
                        <p className="text-[#6A6A6A] text-disclaimer">Αν δεν βλέπεις τη λυχνία παραπάνω πάτησε
                            <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(['other-red'])}> εδώ </span>
                            για κόκκινη ένδειξη και
                            <span className="text-[#D4002A] cursor-pointer" onClick={() => handleSubmit(["other-yellow-orange"])}> εδώ </span>
                            για κίτρινη ή πορτοκαλί ένδειξη.
                        </p>
                    </div>
                </div>

                {/* desktop message block */}
                <div className="w-[626px] rounded-[12px] border border-[#A5A5A5] flex flex-col gap-6 items-center justify-center p-10 max-lg:hidden">
                    <InfoIcon className={'w-12 h-12'} />
                    <p className="text-center text-body-large">{message === undefined ? 'Επίλεξε μία από τις ενδείξεις αριστερά για περισσότερες λεπτομέρειες' : message.label}</p>
                    {message && message.phone && <h4>{message.phone}</h4>}
                </div>
            </div>

            {/* mobile sticky bottom message bar */}
            {!!message && <div className="fixed bottom-0 w-full lg:hidden bg-white border-t border-[#A5A5A5] pt-6 pb-16 px-5" style={{
                boxShadow: '0px -8px 10px 0px #0000000D'
            }}>
                {!!message 
                    ? <div className='flex flex-row gap-5 items-center justify-center'>
                        <InfoIcon className={'w-7 h-7 shrink-0'} />
                        <p>{message.label} {!!message?.phone ? message?.phone : ""}</p>
                        </div>
                    : <></>}
            </div>}
        </div>
    )
}